import { Link } from 'react-router';
import { StateBadge } from '../../../ui/Badge';
import { Card } from '../../../ui/misc';
import type { ReleaseDetail } from '../types';

export function Rollbacks({ r, base }: { r: ReleaseDetail; base: string }) {
  return (
    <Card title="Rollbacks" tight>
      {r.rollbacks.length === 0 ? (
        <span className="small muted">None.</span>
      ) : (
        <ul className="checklist">
          {r.rollbacks.map((rb) => (
            <li key={rb.id} style={{ justifyContent: 'space-between' }}>
              <Link to={`${base}/rollbacks/${rb.displayId}`}>
                <span className="mono">{rb.displayId}</span> {rb.title}
              </Link>
              <StateBadge state={rb.state} />
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
